<template functional>
  <FontAwesomeIcon
    :icon="['fal', 'spinner-third']"
    :class="data.staticClass"
    class="animation-spin transition-transform"
  />
</template>

<script>
export default {};
</script>

<style scoped>
.animation-spin {
  animation: rotate-full 650ms linear infinite;
}

@keyframes rotate-full {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
